var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8701 30.7951C26.1855 18.8382 37.7607 11.0375 49.7241 13.3718L62.1021 15.7869C74.0655 18.1212 81.8867 29.7065 79.5713 41.6633C79.2405 43.3714 77.5868 44.4858 75.8778 44.1524C74.1688 43.8189 73.0515 42.1638 73.3822 40.4557C75.0361 31.9151 69.4497 23.64 60.9043 21.9726L48.5262 19.5575C39.981 17.8901 31.713 23.462 30.0591 32.0027C29.7283 33.7108 28.0747 34.8252 26.3657 34.4917C24.6566 34.1583 23.5393 32.5032 23.8701 30.7951Z",
    fill: "#5775FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.914 14.5797C40.5326 11.5785 25.6501 21.608 22.6732 36.9811L19.0797 55.5381L12.8906 54.3305L16.4842 35.7735C20.1227 16.9841 38.3123 4.7259 57.1119 8.394C75.9112 12.0621 88.2019 30.2675 84.5634 49.0569L80.9699 67.6139L74.7809 66.4063L78.3744 47.8493C81.3513 32.4762 71.2954 17.5808 55.914 14.5797Z",
    fill: "#8A9FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19236 53.4127C3.70104 46.4678 8.93334 40.4488 15.8791 39.9688L22.1672 39.5343C25.6401 39.2943 28.6545 41.9147 28.9002 45.3872L30.7684 71.7942C30.9649 74.5724 28.872 76.98 26.0938 77.1719C14.9806 77.9401 5.3343 69.5547 4.54822 58.4426L4.19236 53.4127Z",
    fill: "#5775FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7447 42.5578C25.6219 40.8215 26.93 39.3167 28.6664 39.1968C30.4028 39.0768 31.91 40.387 32.0329 42.1232L34.257 73.5603C34.3798 75.2965 33.0717 76.8015 31.3353 76.9214C29.5988 77.0414 28.0916 75.7314 27.9687 73.9951L25.7447 42.5578Z",
    fill: "#8A9FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4212 69.9287C92.4684 63.6742 89.8636 56.1258 83.6028 53.0691L77.9346 50.3017C74.8042 48.7733 71.0313 50.0694 69.5077 53.1966L57.9203 76.9785C56.7015 79.4805 57.7435 82.4998 60.2476 83.7223C70.2652 88.6131 82.3384 84.4655 87.214 74.4585L89.4212 69.9287Z",
    fill: "#5775FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7981 49.0981C68.5599 47.5345 70.4466 46.8865 72.0118 47.6506C73.577 48.4148 74.2281 50.3019 73.4663 51.8655L59.6721 80.1774C58.9103 81.741 57.0237 82.3889 55.4585 81.6247C53.8933 80.8605 53.2421 78.9737 54.004 77.4101L67.7981 49.0981Z",
    fill: "#8A9FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.3b124a83bae6882e35458d46f5b14687.svg";
export { ForwardRef as ReactComponent };